<template>
  <ReactPage>
    <veratad-failed-log-report-page></veratad-failed-log-report-page>
  </ReactPage>
</template>

<script>
import ReactPage from '../components/ReactPage.vue';

export default {
  name: "VeratadFailedLogReport",
  components: {
    ReactPage
  }
}
</script>
